import Store from '../Store';

const MailStore = new Store('sourcing/mails');

export {MailStore};